import { isCustomerAdmin } from "./helpers";
const knowledgebasePermissions = {
    knowledgebase: {
        index: (_session) => true,
        edit: (_session) => true,
        show: (_session) => true,
        new: ({ user, customer }) => isCustomerAdmin(user, customer),
        delete: ({ user, customer }) => isCustomerAdmin(user, customer),
    },
};
export default knowledgebasePermissions;
